import { Component, Input, OnInit } from '@angular/core';
import { AbstractAddComponent } from '../../../../shared/abstracts/add/abstract-add/abstract-add.component';
import { IObservation, IPatient } from '@ahryman40k/ts-fhir-types/lib/R4';
import { FormGroup, FormControl, FormArray } from '@angular/forms';

export const INPUTS: any[] = [
  {
    label: 'URIC_ACID',
    unit: 'µmol/l'
  },
  {
    label: 'SERUM_IRON',
    unit: 'µmol/l'
  },
  {
    label: 'Triglicerid',
    unit: 'mmol/l'
  },
  {
    label: 'LDL_CHOLESTEROL',
    unit: 'mmol/l'
  },
  {
    label: 'HDL_CHOLESTEROL',
    unit: 'mmol/l'
  },
  {
    label: 'ALL_CHOLESTEROL',
    unit: 'mmol/l'
  }
];

export const CHECKBOXES: any[] = [
  {
    label: 'SMOKING',
  },
  {
    label: 'ALCOHOL',
  },
  {
    label: 'COFFEE',
  }
];

export function getComp(code: string, display: string, text: string, unit?: string) {
  return new FormGroup({
    code: getCode(code, display, text),
    valueQuantity: getValue(unit ? unit : 'mmol/l')
  });
}

export function getComp2(code: string, display: string, text: string) {
  return new FormGroup({
    code: getCode(code, display, text),
    valueBoolean: new FormControl(),
    valueString: new FormControl()
  });
}

export function getCode(code: string, display: string, text: string) {
  return new FormGroup({
    coding: new FormArray([
      new FormGroup({
        code: new FormControl(code),
        display: new FormControl(display),
        system: new FormControl('http://loinc.org')
      })
    ]),
    text: new FormControl(text)
  });
}

export function getValue(unit: string) {
  return new FormGroup({
    value: new FormControl(),
    unit: new FormControl(unit),
    system: new FormControl('http://unitsofmeasure.org')
  });
}

export function getNote() {
  return new FormGroup({
    text: new FormControl('')
  });
}

@Component({
  selector: 'inc-life-mode-add',
  templateUrl: './life-mode-add.component.html',
  styleUrls: ['./life-mode-add.component.scss'],
})
export class LifeModeAddComponent extends AbstractAddComponent<IObservation> implements OnInit {
  inputs = INPUTS;
  checkboxes = CHECKBOXES;
  @Input() patient: IPatient;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.form.controls.subject.setValue({ display: this.patient.name[0].text, reference: this.patient.id });
    if (this.inData) {
      this.form.patchValue(this.inData);
    }
  }

  save(inData: IObservation) {
    if (inData && inData.note) {
      inData.note.map((note, index) => !inData.component[6 + index].valueBoolean ? note.text = '' : note.text);
    }
    this.inData ? this.callUpdate.emit(inData) : this.callSave.emit(inData);
    this.form.reset(this.form.value);
  }

  resetForm() {
    return new FormGroup({
      id: new FormControl(),
      status: new FormControl('final'),
      subject: new FormGroup({
        reference: new FormControl(''),
        display: new FormControl('')
      }),
      issued: new FormControl(new Date().toISOString()),
      code: getCode('83332-7', 'Lifestyle behaviors impacting physical or mental well-being [PCAM]', 'LIFESTYLE'),
      component: new FormArray([
        getComp('14933-6', 'Urate [Moles/volume] in Serum or Plasma', 'URIC_ACID', 'µmol/l'),
        getComp('14800-7', 'Iron binding capacity [Moles/volume] in Serum or Plasma', 'SERUM_IRON', 'µmol/l'),
        getComp('14927-8', 'Triglyceride [Moles/​volume] in Serum or Plasma', 'Triglicerid'),
        getComp('50840-8', 'Cholesterol in HDL [Moles/volume] in Body fluid', 'HDL_CHOLESTEROL'),
        getComp('53133-5', 'Cholesterol in LDL [Moles/volume] in Body fluid', 'LDL_CHOLESTEROL'),
        getComp('29765-5', 'Cholesterol [Moles/volume] in Body fluid', 'ALL_CHOLESTEROL'),
        getComp2('74013-4', 'Alcoholic drinks per day', 'ALCOHOL'),
        getComp2('63640-7', 'How many cigarettes per day do, or did, you smoke', 'SMOKING'),
        getComp2('61480-0', 'How often did you drink brewed coffee, not decaffeinated', 'COFFEE')
      ]),
      note: new FormArray([
        getNote(),
        getNote(),
        getNote(),
      ])
    });
  }

}
